import React, { useEffect, useRef, useState } from "react";
import WhyCss from "./style";

const WhyCEFA = () => {
  const paraRef = useRef();
  const [visible, setVisible] = useState(false);
  const observer = React.useRef(
    new IntersectionObserver(
      (enteries, ob) => {
        enteries.forEach(entry => {
          if (entry.isIntersecting) setVisible(true);
        });
      },
      { root: null, rootMargin: "-200px 0px", threshold: 0 }
    )
  );
  useEffect(() => {
    observer.current.observe(paraRef.current);
  }, []);

  let classes = "title";
  if (visible) {
    classes += " fadeIn";
  }
  return (
    <WhyCss>
      <div className="wrapper">
        <div className={classes} ref={paraRef}>
          Why CEFA?
        </div>
        <div className="cards">
          <div className="card">
            <div className="image">
              <img src="whyCEFA/1.png" alt="1" />
            </div>
            <div className="text">
              Transactions = dividends + liquidity + scarcity
            </div>
          </div>
          <div className="card">
            <div className="image">
              <img
                style={{ transform: "scale(0.8)", marginTop: "-1.5rem" }}
                src="whyCEFA/2.png"
                alt="1"
              />
            </div>
            <div className="text">
              Regular bonuses for holders like airdrops and bond offerings
            </div>
          </div>
          <div className="card">
            <div className="image">
              <img src="whyCEFA/3.png" alt="1" />
            </div>
            <div className="text">
              Passive income from our yield farming and future games
            </div>
          </div>
        </div>
      </div>
    </WhyCss>
  );
};

export default WhyCEFA;
